export const ORDER_SUCCESS = 'Order cancelled successfully';
